import { defineStore } from 'pinia';

const HIDE_DELAY_MS = 200;
let hideTimeout: ReturnType<typeof setTimeout> | null = null;

function clearHideTimeout() {
  if (hideTimeout !== null) {
    clearTimeout(hideTimeout);
    hideTimeout = null;
  }
}

export const useLoadingStore = defineStore('loading', {
  state: () => ({
    isLoading: false as boolean,
    message: 'Lade Daten' as string,
    requestCount: 0 as number,
  }),
  getters: {
    showLoading: (state) => state.isLoading,
    /**
     * True while requests are actually in flight. Unlike `showLoading`,
     * this is not affected by the artificial hide delay of the overlay
     * and must be used for request deduplication guards.
     */
    hasPendingRequests: (state) => state.requestCount > 0,
  },
  actions: {
    startLoading(message?: string) {
      clearHideTimeout();
      this.requestCount++;
      this.isLoading = true;
      if (message) {
        this.message = message;
      }
    },
    stopLoading() {
      this.requestCount = Math.max(0, this.requestCount - 1);
      if (this.requestCount === 0) {
        clearHideTimeout();
        hideTimeout = setTimeout(() => {
          hideTimeout = null;
          if (this.requestCount === 0) {
            this.isLoading = false;
          }
        }, HIDE_DELAY_MS);
      }
    },
    resetLoading() {
      clearHideTimeout();
      this.requestCount = 0;
      this.isLoading = false;
    },
  },
});
